import { useGetGuideStepsQuery, useGetUserGuideStepsQuery } from '../api'

export const useGuideSteps = (options = {}) => {
  const { data: guideStepsResponse } = useGetGuideStepsQuery(undefined, options)
  const { data: userGuideSteps } = useGetUserGuideStepsQuery(undefined, options)

  if (!guideStepsResponse || !userGuideSteps) return null

  const guideSteps = guideStepsResponse.collection?.map((step) => ({
    ...step,
    userGuideSteps: userGuideSteps.collection.filter(({ guideStepUuid }) => guideStepUuid === step.uuid)
  }))

  const collection = guideSteps?.filter(({ parentUuids }) => !parentUuids[0]).map((section) => ({
    ...section,
    steps: guideSteps.filter(({ parentUuids }) => parentUuids.some((parentUuid) => parentUuid === section.uuid))
  }))

  return { collection }
}
